import script from "./tpr.vue?vue&type=script&setup=true&lang=ts"
export * from "./tpr.vue?vue&type=script&setup=true&lang=ts"

import "./tpr.vue?vue&type=style&index=0&id=b8354b92&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b8354b92"]])

export default __exports__